var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('h1',{staticClass:"font-weight-bold break-word",class:[_vm.titleDisplay, _vm.textCenter],style:([{color: _vm.titleColor}])},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }